// extracted by mini-css-extract-plugin
export default {"container":"vl-z","freeShip":"wl-z","privacy":"xl-z"};